export default __webpack_public_path__ + "static/media/cesto_pannocchie.cc79c3cd.svg";